import React from 'react';
import { get } from 'lodash/fp';
import { branch, renderComponent } from 'recompose';
import { Form } from 'semantic-ui-react';

export const handleReadOnly = branch(
  get('readOnly'),
  renderComponent(({ value }) => <Form.Input value={value} disabled />),
);
